var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
export default class GradeDictEntry {
    id;
    refId = null;
    title;
    parent = null;
    cellWidth = 0;
    cellOffset = 0;
    constructor({ id, refId, title, parent }) {
        this.id = id;
        this.refId = refId;
        this.title = title;
        this.parent = parent;
    }
    get group() {
        return this.title.replace(/[^a-zA-Z]/g, '');
    }
    get isSubgrade() {
        return !!this.parent;
    }
    setWidth = (cellWidth) => {
        this.cellWidth = cellWidth;
    };
    setOffset = (cellOffset) => {
        this.cellOffset = cellOffset;
    };
}
__decorate([
    observable
], GradeDictEntry.prototype, "refId", void 0);
__decorate([
    observable
], GradeDictEntry.prototype, "title", void 0);
__decorate([
    observable
], GradeDictEntry.prototype, "parent", void 0);
__decorate([
    observable
], GradeDictEntry.prototype, "cellWidth", void 0);
__decorate([
    observable
], GradeDictEntry.prototype, "cellOffset", void 0);
__decorate([
    computed
], GradeDictEntry.prototype, "group", null);
__decorate([
    computed
], GradeDictEntry.prototype, "isSubgrade", null);
__decorate([
    action
], GradeDictEntry.prototype, "setWidth", void 0);
__decorate([
    action
], GradeDictEntry.prototype, "setOffset", void 0);
